<template>
  <div class="container">
    <div class="auth__register-page row">
      <div class="auth__register-form col-xs-12 col-md-8 pt-3">
        <h2 class="auth__register-title">Create an account</h2>
        <vue-form-generator
        :schema="schema"
        :model="model"
        :options="formOptions"
        ></vue-form-generator>
      </div>
      <div class="auth__register-promo col-md-4 d-none d-md-block">
        <b-img
        src="./static/auth/promo-person.png"
        alt="Create your account"
        class="auth__register-promo__img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import helper from '@/libs/helper';

import { LOGIN } from '@/vuex/types/actions';

import VueFormGenerator from 'vue-form-generator';
import BasicHeader from '@/components/utils/BasicHeader';

import SCHEMA from '@/components/auth/invitation/schema';
import MODEL from '@/components/auth/invitation/model.json';


export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    BasicHeader,
  },
  props: {
    firstName: String,
    lastName: String,
    userEmail: String,
    phoneNumber: String,
    code: String,
  },
  data() {
    return {
      model: helper.copy(MODEL),
      schema: SCHEMA.schema(this.register, this.validatePasssword),
      formOptions: SCHEMA.options,
    };
  },
  methods: {
    register() {
      const data = {
        userEmail: this.model.userEmail,
        password: this.model.password,
        code: this.model.code,
        fromMobile: this.model.fromMobile,
        optIn: this.model.optIn,
      };

      this.$reqs.post('/register_from_invite', data)
        .then((response) => {
          if (process.env.NODE_ENV !== 'development') {
            this.$ga.event({
              eventCategory: 'CompleteRegistration',
              eventAction: 'Completed',
            });
            if (process.env.NODE_ENV === 'production') {
              this.$analytics.fbq.event('CompleteRegistration');
            }
          }
          this.$store.dispatch(LOGIN, response.data);
          this.$router.push({ name: 'Index' });
        })
        .catch((err) => {
          if (err.data && err.data.redirectToLogin) {
            this.$router.push({ name: 'Login' });
          } else {
            this.model.password = null;
            this.model.password2 = null;
          }
        });
    },
    validatePasssword(value) {
      if (value && value.length >= 8 && value !== this.model.password) {
        return ['Passwords must match'];
      }

      return null;
    },
  },
  created() {
    helper.map(this.$props, this.model);
    if (this.$props.phoneNumber) {
      this.model.phoneNumber = helper.phoneMask(this.$props.phoneNumber);
    }
  },
};
</script>

<style scoped>
.auth__register-page {
  display: flex;
  align-items: center;
  height: calc(100vh - 68px);
}

.auth__register-title {
  font-weight: 375;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0.0025em;
  color: #000000;
  margin-bottom: 16px;
}

.auth__submit-button input {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 20px;
  background-color: #2E78C2;
  color: #ffffff;
  border-radius: 4px;
}
.auth__submit-button {
  padding: 0 25px 0 5px;
}

.auth__register-form .vue-form-generator {
  padding: 0;
  margin: 0 -15px;
}
.auth__register-promo__img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/invitation/Invitation.vue